/** Drop a trailing ", United States" / ", USA" from an address so US-based
 * trips don't waste horizontal space on a redundant country suffix. Anything
 * else (Mexico, Canada, etc.) passes through untouched. Whitespace + trailing
 * punctuation are tolerated. */
export const formatAddress = (raw: string | null | undefined): string => {
  if (!raw) return '';
  return raw.replace(/,\s*(United States|USA|U\.S\.A?\.?)\s*,?\s*$/i, '').replace(/,\s*$/, '');
};
